import BestOffers from "./BestOffers";

export default BestOffers;